import { postMultipart } from '../client'

export const uploadInvoice = (file) => {
  const data = new FormData()
  data.append('file', file)

  return postMultipart('invoice_scan', data)
}
